import {
	Modal,
	Button,
	FormControl,
	Tooltip,
	OverlayTrigger,
} from 'react-bootstrap';
import { useFormik } from 'formik';
import { BsQuestionCircle } from 'react-icons/bs';
import { addParticipantValidate } from '@/utils/validation';
import { constant, modal } from '@/utils/constant';
import { emitUpdateParticipant } from '@/utils/socketHelpers';

function EditParticipants({ hide, show, editData, socket, sessionData }) {
	const formik = useFormik({
		initialValues: {
			firstName: editData.first_name,
			lastName: editData.last_name,
			private_note: editData.private_note,
		},
		validationSchema: addParticipantValidate,
		onSubmit: async values => {
			if (
				values.firstName !== editData.first_name ||
				values.lastName !== editData.last_name ||
				values.private_note !== editData.private_note
			) {
				let newValue = {
					id: editData.id,
					first_name: values.firstName,
					last_name: values.lastName,
					private_note: values.private_note,
				};
				try {
					const data = await emitUpdateParticipant(socket, newValue);

					if(data?.status){
						socket.emit('store-session-welcome-model-first-last-name',{
							session_id: Number(sessionData?.id),
							id: editData.id,
							first_name: values.firstName,
							last_name: values.lastName
						});
					}
					socket.emit('register-session-random-assign', sessionData?.id);
					hide();
				} catch (error) {}
			} else {
				hide();
			}
		},
	});

	return (
		<>
			<Modal
				show={show}
				onHide={hide}
				size='md'
				centered
			>
				<Modal.Header
					className='bg-secondary'
					closeButton
				>
					<Modal.Title>{modal?.editParticipantModalTital}</Modal.Title>
				</Modal.Header>
				<Modal.Body className='py-10'>
					<form className='mx-auto form'>
						<div>
							<label
								className='form-label'
								htmlFor='firstName'
							>
								{constant?.firstName}
							</label>
							<FormControl
								value={formik.values.firstName}
								onChange={formik.handleChange}
								name='firstName'
								placeholder='Jane'
							/>
							{formik.submitCount > 0 && formik.errors.firstName && (
								<div className='text-danger'>{formik.errors.firstName}</div>
							)}
						</div>
						<div className='mt-6'>
							<label
								className='form-label'
								htmlFor='lastName'
							>
								{constant?.lastName}
							</label>
							<FormControl
								value={formik.values.lastName}
								onChange={formik.handleChange}
								name='lastName'
								placeholder='Doe'
							/>
							{formik.submitCount > 0 && formik.errors.lastName && (
								<div className='text-danger'>{formik.errors.lastName}</div>
							)}
						</div>
						<div className='mt-6'>
							<OverlayTrigger
								placement='bottom'
								overlay={
									<Tooltip
										id='button-tooltip-2'
										className='tooltip-light'
									>
										<p className='mb-2'>{modal?.privateNoteModelTooltip}</p>
									</Tooltip>
								}
							>
								{({ ref, ...triggerHandler }) => (
									<div
										{...triggerHandler}
										className='d-inline-flex align-items-center form-label'
									>
										<span className='me-2'>{modal?.privateNote}</span>
										<span
											ref={ref}
											className='lh-none'
										>
											<BsQuestionCircle />
										</span>
									</div>
								)}
							</OverlayTrigger>
							<FormControl
								name='private_note'
								type='text'
								value={formik.values.private_note}
								onChange={formik.handleChange}
							/>
							{formik.submitCount > 0 && formik.errors.private_note && (
								<div className='text-danger'>{formik.errors.private_note}</div>
							)}
						</div>
						<div className='px-2'>
							<Button
								variant='secondary'
								size='lg'
								className='w-full mt-lg-16 mt-10'
								onClick={formik.handleSubmit}
							>
								{modal?.saveChanges}
							</Button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		</>
	);
}
export default EditParticipants;
